<!-- 自建应用 -->
<template>
  <div>
    <div class="head-title">自建应用</div>
    <div class="row">
      <div class="row-head">基础应用</div>
      <div class="row-content">
        <div class="col-box">
          <div class="col" @click="onShowPayPop">
            <div class="col-l">
              <el-image
                style="width: 48px; height: 3.2rem"
                :src="zhifu"
              ></el-image>
            </div>
            <div class="col-r">
              <div class="col-r-t">企业支付</div>
              <div class="col-r-b"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="企业支付" center width="40%" :visible.sync="PayDialogVisible">
      <div class="dialog-header">
        <div class="dialog-header-l">
          <el-image style="width: 68px; height: 68px" :src="zhifu"></el-image>
          <div class="name">企业支付</div>
        </div>
        <div class="dialog-header-r">
          <el-button size="small" @click="onPayState">
            <template v-if="PayStateEdit"> 取消 </template>
            <template v-else> 修改</template>
          </el-button>
        </div>
      </div>
      <div class="help">
        <p>
          只需要绑定已有的微信支付商户号，即可在企业微信内使用支付能力，企业成员可以给客户发红包（直接付款到客户的微信零钱）。<a
            class="help-link"
            href="https://www.weijub.com/index/index/news_detail?id=121"
            target="_blank"
            rel="noopener noreferrer"
            >如何配置企业支付？</a
          >
        </p>
      </div>
      <el-form :model="payForm" label-width="14.0rem">
        <el-form-item label="IP地址:">
          <div>
            <span class="help-link">
              118.195.194.112,118.195.184.15,118.195.175.43,118.195.193.189</span
            >
            <el-button
              class="btn"
              type="primary"
              icon="el-icon-copy-document"
              style="margin-left: 1.2rem; padding: .7rem"
              size="mini"
              data-clipboard-text="118.195.194.112,118.195.184.15,118.195.175.43,118.195.193.189"
              >复制</el-button
            >
          </div>
          <div class="tips" style="margin-top: .6rem">
            请在商户平台，将该IP地址填入【企业付款API安全】中，以保证支付功能正常使用
          </div>
        </el-form-item>
        <el-form-item label="微信支付商户号:">
          <span v-show="!PayStateEdit" class="item-span">
            <span v-if="payForm.corp_id">
              {{ payForm.corp_id }}
            </span>
            <span v-else> 未填写微信支付商户号 </span>
          </span>
          <el-input
            v-show="PayStateEdit"
            v-model="payForm.corp_id"
            size="small"
            placeholder="请输入微信支付商户号"
          ></el-input>
        </el-form-item>
        <el-form-item label="微信支付密钥:">
          <span v-show="!PayStateEdit" class="item-span">
            <span v-if="payForm.corp_secret">
              {{ payForm.corp_secret }}
            </span>
            <span v-else> 未填写微信支付密钥 </span>
          </span>
          <el-input
            v-show="PayStateEdit"
            v-model="payForm.corp_secret"
            size="small"
            placeholder="请输入微信支付密钥"
          ></el-input>
        </el-form-item>
        <el-form-item label="apiclient_cert文件:">
          <div class="flex">
            <span v-if="payForm.apiclient_cert" class="item-span file-span"
              ><i class="el-icon-tickets"></i>apiclient_cert文件已上传</span
            >
            <span v-else class="item-span file-span">
              请上传apiclient_cert文件
            </span>
            <el-upload
              v-show="PayStateEdit"
              class="upload-demo"
              accept=".pem"
              :show-file-list="false"
              :action="`${axios.defaults.baseURL}/api/index/uploads2`"
              :on-success="handleSuccessCert"
            >
              <el-button size="mini" icon="el-icon-upload2">
                {{ payForm.apiclient_cert ? "重新" : "点击" }}上传
              </el-button>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="apiclient_key文件:">
          <div class="flex">
            <span v-if="payForm.apiclient_key" class="item-span file-span"
              ><i class="el-icon-tickets"></i>apiclient_key文件已上传</span
            >
            <span v-else class="item-span file-span">
              请上传apiclient_key文件
            </span>
            <el-upload
              v-show="PayStateEdit"
              class="upload-demo"
              accept=".pem"
              :show-file-list="false"
              :action="`${axios.defaults.baseURL}/api/index/uploads2`"
              :on-success="handleSuccessKey"
            >
              <el-button size="mini" icon="el-icon-upload2">
                {{ payForm.apiclient_key ? "重新" : "点击" }}上传
              </el-button>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="PayDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUpdate">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ClipboardJS from "clipboard";
let clipboard;
export default {
  name: "selfApplication",
  components: {},

  data() {
    return {
      zhifu: require("@/assets/zhifu.svg"),
      PayDialogVisible: false,
      payForm: {
        corp_id: "",
        corp_secret: "",
        apiclient_cert: "",
        apiclient_key: "",
      },
      fileListKey: [],
      fileListCert: [],
      PayStateEdit: false,
    };
  },

  computed: {},

  mounted() {
    this.initCopy(".btn");
  },
  destroyed(){
    clipboard.destroy();
  },

  methods: {
    initCopy(selector = ".btn") {
      clipboard = new ClipboardJS(selector);
      clipboard.on("success", (e) => {
        if (e.text == 0) {
          this.$message.error("复制失败，请稍后再试");
        } else {
          this.$message.success("复制成功");
        }
        e.clearSelection();
      });

      clipboard.on("error", () => {
        this.$message.error("复制失败，请稍后再试");
      });
    },
    async getConfigList() {
      try {
        const { data: res } = await this.axios({
          url: "/crm/WxpayConfig/getConfigList",
          method: "POST",
          data: this.qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
        });
        if (res.code == 1) {
          const d = res.data;
          this.payForm.corp_id = d.corp_id;
          this.payForm.corp_secret = d.corp_secret;
          this.payForm.apiclient_cert = d.apiclient_cert;
          this.payForm.apiclient_key = d.apiclient_key;
          // this.fileListCert = [
          //   {
          //     url: d.apiclient_cert,
          //     name: d.apiclient_cert,
          //   },
          // ];
          // this.fileListKey = [
          //   {
          //     url: d.apiclient_key,
          //     name: d.apiclient_key,
          //   },
          // ];
        } else if (res.code == 0) {
          // this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async addUpdate() {
      try {
        const { data: res } = await this.axios({
          url: "/crm/WxpayConfig/addUpdate",
          method: "POST",
          data: this.qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            corp_id: this.payForm.corp_id,
            corp_secret: this.payForm.corp_secret,
            apiclient_cert: this.payForm.apiclient_cert,
            apiclient_key: this.payForm.apiclient_key,
          }),
        });
        if (res.code == 1) {
          this.$message.success(res.msg);
          this.PayDialogVisible = false;
        } else if (res.code == 0) {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    onPayState() {
      this.PayStateEdit = !this.PayStateEdit;
    },
    async onShowPayPop() {
      this.PayStateEdit = false
      await this.getConfigList();
      this.PayDialogVisible = true;
    },
    handleSuccessCert(res, file, fileList) {
      if (res.code == 1) {
        this.$message.success(res.msg);
        this.payForm.apiclient_cert = res.data;
        console.log(res);
      } else {
        this.$message.error(res.msg);
      }
    },
    handleExceedCert(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    handleSuccessKey(res, file, fileList) {
      if (res.code == 1) {
        this.$message.success(res.msg);
        this.payForm.apiclient_key = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    handleExceedKey(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.row {
  border: 1px solid #e8e8e8;
  padding: 2.0rem 0;
  color: rgb(24, 24, 24);
  &-head {
    border-bottom: 1px solid #e8e8e8;
    padding: 0 2.0rem 2.0rem 2.0rem;
  }
  &-content {
    padding: 2.0rem .0rem .0rem .0rem;
    display: flex;
    flex-wrap: wrap;
    .col-box {
      width: 25%;
      padding: 2.0rem;
      .col {
        padding: 3.0rem 2.0rem;
        display: flex;
        border: 1px solid #e8e8e8;
        cursor: pointer;
        &-r {
          display: flex;
          flex-direction: column;
          justify-content: center;
          &-b {
            margin-top: 8px;
            font-size: 1.4rem;
            color: rgba(53, 53, 53, 0.42);
          }
        }
      }
    }
  }
}

// 企业支付弹窗
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 2.0rem;
  &-l {
    padding-left: 6.0rem;
    display: flex;
    align-items: center;
    .name {
      margin-left: 1.2rem;
      font-size: 18px;
    }
  }
}
.tips {
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.6rem;
  font-size: 1.3rem;
}
.item-span {
  color: rgba(0, 0, 0, 0.6);
}
.flex {
  display: flex;
  align-items: center;
}
.file-span {
  margin-right: 1.2rem;
}
</style>